module.exports = __webpack_public_path__ + "media/images/black_bg-7a357cfc.png";